<nz-form-item class="label-on-top">
  <nz-form-label *ngIf="label" [nzRequired]="isRequired(control)">
    {{ label }}
  </nz-form-label>
  <nz-form-control nzHasFeedback [nzErrorTip]="errorTemplate" [nzValidateStatus]="control">
    <nz-time-picker
      [formControl]="control"
      [nzDefaultOpenValue]="defaultOpenValue"
      [nzDisabled]="isDisabled"
      [nzPlaceHolder]="placeholder"
      [nzSize]="size"
    >
    </nz-time-picker>
  </nz-form-control>
  <ng-template #errorTemplate>
    {{ control.errors | formError }}
  </ng-template>
</nz-form-item>
